export const LOCAL_MODELS = [
  { id: "Qwen2.5-0.5B-Instruct-q4f16_1-MLC", name: "Qwen 2.5 · 0.5B", size: "≈ 0,9 Go", tier: "Très léger", note: "Tout PC récent, réponses basiques" },
  { id: "Qwen2.5-1.5B-Instruct-q4f16_1-MLC", name: "Qwen 2.5 · 1.5B", size: "≈ 1,6 Go", tier: "Recommandé", note: "Bon équilibre qualité / vitesse" },
  { id: "Llama-3.2-1B-Instruct-q4f16_1-MLC", name: "Llama 3.2 · 1B", size: "≈ 0,9 Go", tier: "Léger", note: "Rapide, correct en français" },
  { id: "Qwen2.5-3B-Instruct-q4f16_1-MLC", name: "Qwen 2.5 · 3B", size: "≈ 2,5 Go", tier: "Plus puissant", note: "Meilleures réponses, carte graphique conseillée" },
];

export const DEFAULT_MODEL = "Qwen2.5-1.5B-Instruct-q4f16_1-MLC";

export function recommendLocalModel(hw) {
  const ram = hw.ram || 0;
  const vram = hw.vram || 0;
  if (hw.accelerator === "metal") {
    if (ram >= 16) return "Qwen2.5-3B-Instruct-q4f16_1-MLC";
    return ram >= 8 ? DEFAULT_MODEL : "Qwen2.5-0.5B-Instruct-q4f16_1-MLC";
  }
  if (hw.accelerator === "cpu" || vram < 1) return ram >= 8 ? "Llama-3.2-1B-Instruct-q4f16_1-MLC" : "Qwen2.5-0.5B-Instruct-q4f16_1-MLC";
  if (vram >= 4) return "Qwen2.5-3B-Instruct-q4f16_1-MLC";
  return vram >= 2 ? DEFAULT_MODEL : "Llama-3.2-1B-Instruct-q4f16_1-MLC";
}

let enginePromise = null;
let loadedModel = null;

const lib = () => import("@mlc-ai/web-llm");

export async function checkWebGPU() {
  if (!("gpu" in navigator)) return { ok: false, reason: "nogpu" };
  try {
    const adapter = await navigator.gpu.requestAdapter();
    return adapter ? { ok: true } : { ok: false, reason: "noadapter" };
  } catch {
    return { ok: false, reason: "noadapter" };
  }
}

export async function isCached(modelId) {
  try {
    return await (await lib()).hasModelInCache(modelId);
  } catch {
    return false;
  }
}

export async function deleteCached(modelId) {
  await (await lib()).deleteModelAllInfoInCache(modelId);
  if (loadedModel === modelId) {
    const engine = await enginePromise;
    await engine.unload();
    enginePromise = null;
    loadedModel = null;
  }
}

export function getLoadedModel() {
  return loadedModel;
}

export async function loadModel(modelId, onProgress) {
  const webllm = await lib();
  if (!enginePromise) {
    const worker = new Worker(new URL("./localLlm.worker.js", import.meta.url), { type: "module" });
    enginePromise = webllm.CreateWebWorkerMLCEngine(worker, modelId, { initProgressCallback: onProgress });
    try {
      await enginePromise;
    } catch (e) {
      enginePromise = null;
      throw e;
    }
  } else if (loadedModel !== modelId) {
    const engine = await enginePromise;
    engine.setInitProgressCallback(onProgress);
    await engine.reload(modelId);
  }
  loadedModel = modelId;
  return enginePromise;
}

export async function streamChat(messages, onDelta) {
  const engine = await enginePromise;
  const chunks = await engine.chat.completions.create({ messages, stream: true, temperature: 0.6 });
  let full = "";
  for await (const c of chunks) {
    const d = c.choices[0]?.delta?.content || "";
    full += d;
    onDelta(full);
  }
  return full;
}

export async function stopChat() {
  if (enginePromise) (await enginePromise).interruptGenerate();
}
